import RequestService from '../../../services/request-service';
import MatchModel from '../../../models/model-match';
import { LAYOUT_NAME } from '../../../models/enums/layout-const';

/**
 * Matches Request Service, used to get data on home page
 */
export default class UpcomingService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.getUpcoming;
    this.method = 'get';
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      Culture: Culture,
      StartRecord: 0,
      EndRecord: 20,
      SportID: null,
      TimeOffset: -60,
      NumberOfOddTypes: 3,
      Minutes: 320,
      isMultiMarket: APP_SETTINGS.settings.layout === LAYOUT_NAME.US
    };
    this.headers = null;
  }

  /**
   * fillDate will map API data with our model data
   * @param data received pure API data
   * @return array of MatchModel objects
   */
  fillDate(data) {
    return data.m.map(m => new MatchModel(m));
  }
}
